/* eslint-disable no-return-assign */
export default {
  namespaced: true,
  state: {
    dataDomain: {
      items: {},
      fields: [
        { key: 'url', label: 'URL', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'actions', label: '' },
      ],
      status: [
        {
          1: 'Waiting Approval', 2: 'Approved', 3: 'Rejected',
        },
        {
          1: 'light-warning', 2: 'light-success', 3: 'light-danger',
        },
      ],
    },
  },
  getters: {
    getDomainItem: state => state.dataDomain.items,
    getDomainField: state => state.dataDomain.fields,
    getDomainStatus: state => state.dataDomain.status,
  },
  mutations: {
    SET_DATA_DOMAIN_ITEM: (state, value) => (value ? (state.dataDomain.items = value) : (state.dataDomain.items = [])),
  },
  actions: {
    getDataDomain: ({ commit }) => {
      const dataDomain = {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [
          {
            url: 'getConnected.com', type: 'https',
          },
          {
            url: 'getConnected.com', type: 'https',
          },
          {
            url: 'getConnected.com', type: 'https',
          },
          {
            url: 'getConnected.com', type: 'https',
          },
          {
            url: 'getConnected.com', type: 'https',
          },
          {
            url: 'getConnected.com', type: 'https',
          },
          {
            url: 'getConnected.com', type: 'https',
          },
        ],
      }
      commit('SET_DATA_DOMAIN_ITEM', dataDomain)
    },
    getDomain({ commit, getters }, payload) {
      const search = typeof payload.search !== 'undefined' ? payload.search : ''
      const status = typeof payload.status !== 'undefined' ? payload.status : ''
      const sortBy = typeof payload.sortBy !== 'undefined' ? payload.sortBy : ''
      const sortDirection = typeof payload.sortDirection !== 'undefined' ? payload.sortDirection : ''

      return new Promise((resolve, reject) => {
        // MENGGUNAKAN AXIOS PADA URL /ACCOUNT
        this.apiAccess.get(`/product?page=${getters.getDomainItem.current_page}&filter=${search}&sortby=${sortBy}&sortdir=${sortDirection}&status=${status}`)
          .then(response => {
            // APABILA MENDAPATKAN RESPONSE, DATA AKAN DICOMMIT KE MUTATION SET_DATA_DOMAIN_ITEM
            commit('SET_DATA_DOMAIN_ITEM', response.data)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
}
